<script>
import { mapState } from "vuex";

export default {
  name: "iframePage",
  computed: {
    ...mapState(["propiedadActiva"]),
   
    containerStyles() {
      if (this.$route.name === "pageSubscription") {
        return {
          background: "#fff",
          width: "100%",
          "min-height": "100vh",
          padding: "8%",
        };
      } else {
        return {
          "padding-inline": !this.$isMobile ? "8%" : "0",
        }; // Estilos por defecto cuando no hay coincidencia
      }
    },
  },
};
</script>
<template>
  <div
    :class="[
      'iframe-layout',
      'contenedor-main',
      {
        'no-padding-inline':
          $route.name === 'hotelReservationCalendar' ||
          $route.name === 'hotelReservationCalendar',
      },
    ]"
    :style="containerStyles"
  >
    <div class="container-fluid p-0">
      <router-view></router-view>
    </div>
  </div>
</template>
<style lang="scss">
.botonGuardarDB {
  color: white !important;
  padding: 11px;
  font-size: 15px;
  float: right;
  background: rgb(17, 177, 77);
  border-radius: 10px;
  font-weight: 700;
}

/* OJO: este <style> NO es scoped. `.contenedor-main` es la clase del contenedor de
   TODOS los layouts, así que estas reglas se colaban en el panel principal (Maqueta)
   y le pisaban su padding real (izq 8% / der 2%) con un 18% centrado. Se acotan con
   `.iframe-layout`, la clase propia de ESTE layout. */
@media (min-width: 1450px) {
  .iframe-layout.contenedor-main {
    padding-inline: 18% !important;
  }

  .iframe-layout.contenedor-main.no-padding-inline {
    padding-inline: 0 !important;
  }
}

@media (min-width: 768px) {
  .iframe-layout.contenedor-main {
    padding-top: 3% !important;
    text-align: left;
    width: 100%; // Mantener el mismo ancho siempre
    transition: margin-left 0.4s cubic-bezier(0.25, 0.8, 0.25, 1); /* Suavidad mejorada */
  }

  .iframe-layout.contenedor-main-expanded {
    padding-left: 240px; // Solo mover el contenedor a la derecha cuando el sidebar esté expandido
    transition: width 0.3s ease-in-out;
  }
}
</style>
